const rolledElements = document.querySelectorAll(".rolled");

rolledElements.forEach((rolledElement) => {
  if (rolledElement) {
    if (rolledElement.offsetHeight > 550) {
      rolledElement.style.height = "550px";
      rolledElement.style.overflow = "hidden";

      const button = document.createElement("a");
      button.classList.add(
        "btn-solid",
        "btn-black",
        "bg-black",
        "mt-5",
        "rolled"
      );
      button.textContent = "Rozwiń";

      rolledElement.insertAdjacentElement("afterend", button);

      button.addEventListener("click", () => {
        if (rolledElement.classList.contains("expand")) {
          rolledElement.classList.remove("expand");
          rolledElement.style.height = "550px";
          rolledElement.style.overflow = "hidden";
          button.classList.remove("expand");
          button.classList.add("rolled");
          button.textContent = "Rozwiń";
        } else {
          rolledElement.classList.add("expand");
          rolledElement.style.height = "100%";
          rolledElement.style.overflow = "visible";
          button.classList.remove("rolled");
          button.classList.add("expand");
          button.textContent = "Zwiń";
        }
      });
    }
  }
});
